import { render, staticRenderFns } from "./AppGithub.vue?vue&type=template&id=3782bb16&scoped=true&"
import script from "./AppGithub.vue?vue&type=script&lang=js&"
export * from "./AppGithub.vue?vue&type=script&lang=js&"
import style0 from "./AppGithub.vue?vue&type=style&index=0&id=3782bb16&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3782bb16",
  null
  
)

export default component.exports